module.exports = __webpack_public_path__ + "img/firebaseLogo.1c454859.png";